import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  StorageModel,
  loadArrayFromLocalStorage,
  localStorageKeys,
} from "../../utils/localStorage";
import { ParcelProduct } from "../../interfaces/ParcelProduct";

export interface Products {
  searchRows: ParcelProduct[];
}

const initialState: Products = {
  searchRows: [],
};

export interface InputQuantity {
  id: number;
  quantity: number;
}

export const parcelSlice = createSlice({
  name: "parcelProduct",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<ParcelProduct[]>) => {
      const localStorageData: StorageModel[] = loadArrayFromLocalStorage(
        localStorageKeys.likeProduct
      );

      action.payload.forEach((item1, i) => {
        const existedData = localStorageData.find(
          (item2) => item1.id === item2.id
        );
        if (existedData) {
          state.searchRows[i] = { ...item1, isLike: existedData.isLike };
        } else {
          state.searchRows[i] = action.payload[i];
        }
      });
    },
    setLike: (state, action: PayloadAction<number>) => {
      const target = state.searchRows.find(
        (item) => item.id === action.payload
      );
      if (target) {
        target.isLike = !target.isLike;
      }
    },
  },
});

export const { set, setLike } = parcelSlice.actions;
export default parcelSlice.reducer;
